import { DefaultCardTypeNames } from '../types/foldersTypes';
/** A constant type object representing a Folder Card Type */
export const Folder = { value: DefaultCardTypeNames.Folder };
/** A constant type object representing a Word Document Card Type */
export const Word = { value: DefaultCardTypeNames.Word };
/** A constant type object representing a Excel Document Card Type */
export const Excel = { value: DefaultCardTypeNames.Excel };
/** A constant type object representing a PowerPoint Document Card Type */
export const PowerPoint = { value: DefaultCardTypeNames.PowerPoint };
//# sourceMappingURL=foldersConstants.js.map